import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

import Input from "@material-ui/core/Input";

import Checkbox from "@material-ui/core/Checkbox";

import Button from "@material-ui/core/Button";

import { currency } from "../../lib/api/currency";
import { getClientByCurrencyId } from "../../lib/api/clientsfinance";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
    },
    tableRow: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1) * 2,
      marginTop: theme.spacing(1),
      textAlign: "right",
    },
    tableRowCombo: {
      paddingTop: theme.spacing(1),
      paddingRight: "10.9em",
      marginTop: theme.spacing(1),
      textAlign: "left",
    },
    codeInput: {
      width: "100%",
      float: "left",
    },
  });

type CurrencyEditFormProps = {
  onSubmit: any;
  onClose: any;
  id: any;
} & WithStyles<typeof styles>;

class CurrencyEditFormUnstyled extends React.Component<CurrencyEditFormProps, any> {
  state = {
    classes: undefined,
    item: { id: "0", code: "", name: "", local: false, active: false },
    onSubmit: undefined,
    onClose: undefined,
    id: 0,
  };

  constructor(props) {
    super(props);
    this.state.classes = props.classes;
    this.state.onSubmit = props.onSubmit;
    this.state.onClose = props.onClose;
    this.state.id = props.id;
  }

  componentDidMount() {
    if (this.state.id != 0) {
      this.getItem(this.state.id);
    }
  }

  getItem = (id) => {
    currency.single(id).then((data) => {
      this.setState({ item: data });
    });
    getClientByCurrencyId(id).then((res) => {
      this.setState({ disabled: !!res.data.currency_id });
    });
  };

  handleFocus = (event) => {
    event.target.select();
  };

  handleSubmit = (e) => {
    this.state.onSubmit(e, this.state.item);
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        <form
          id={this.state.item.id}
          onSubmit={(e) => {
            this.handleSubmit(e);
          }}
        >
          <table style={{ marginLeft: "15px" }}>
            <tbody>
              <tr className={classes.tableRow}>
                <td className={classes.tableRow}>
                  <span>Active:</span>
                </td>
                <td className={classes.tableRowCombo}>
                  <Checkbox
                    key={"body_value_active"}
                    checked={this.state.item["active"]}
                    value={this.state.item["active"]}
                    name="active"
                    onChange={(e) => {
                      this.setState({
                        item: {
                          ...this.state.item,
                          active: e.target.checked,
                        },
                      });
                    }}
                  />
                </td>
              </tr>
              <tr className={classes.tableRow}>
                <td className={classes.tableRow}>
                  <span>Code:</span>
                </td>
                <td className={classes.tableRow}>
                  <Input
                    className={classes.codeInput}
                    onFocus={this.handleFocus}
                    key={"body_value_code"}
                    name={"code"}
                    value={this.state.item.code}
                    onChange={(e) => {
                      this.setState({
                        item: { ...this.state.item, code: e.target.value },
                      });
                    }}
                  />
                </td>
              </tr>
              <tr className={classes.tableRow}>
                <td className={classes.tableRow}>
                  <span>Name:</span>
                </td>
                <td className={classes.tableRow}>
                  <Input
                    className={classes.codeInput}
                    onFocus={this.handleFocus}
                    key={"body_value_name"}
                    name={"name"}
                    value={this.state.item.name ? this.state.item.name : ""}
                    onChange={(e) => {
                      this.setState({
                        item: { ...this.state.item, name: e.target.value },
                      });
                    }}
                  />
                </td>
              </tr>
              <tr className={classes.tableRow}>
                <td className={classes.tableRow}>
                  <span>Local:</span>
                </td>
                <td className={classes.tableRowCombo}>
                  <Checkbox
                    key={"body_value_local"}
                    checked={this.state.item["local"]}
                    value={this.state.item["local"].toString()}
                    name="local"
                    onChange={(e) => {
                      this.setState({
                        item: {
                          ...this.state.item,
                          local: e.target.checked,
                        },
                      });
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px", marginRight: "15px" }}>
            <Button style={{ marginRight: "10px" }} color="secondary" variant="outlined" onClick={this.state.onClose}>
              <Close />
            </Button>
            <Button type="submit" color="primary" variant="outlined" onClick={this.handleSubmit}>
              <Check />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(CurrencyEditFormUnstyled);
